export class InstantRestoreOptions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "promotionWindow",
            "baseName": "promotionWindow",
            "type": "InstantRestorePromotionWindow",
            "format": ""
        },
        {
            "name": "managementSecurityGroupId",
            "baseName": "managementSecurityGroupId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return InstantRestoreOptions.attributeTypeMap;
    }
    constructor() {
    }
}
